import { StructuredDiagnosisColumn, StructuredDiagnosisColumnItem } from './study-report-text';

export class StudyReportEdit {
  public Protocol: string;
  public PracticeName: string;
  public ServiceName: string;
  public StudyReportText: string;
  public StudyReportConclusion: string;
  public StudyReportPdf: string;
  public DeliveryDate?: Date;
  public PhysicianId: number;
  public StudyReportId: number;
  public MedicalApponitmentId: number;
  public PatientId: number;
  public PhysicianSignatureOne?: number;
  public PhysicianSignatureTwo?: number;
  public PhysicianSignatureThree?: number;
  public PhysicianSignatureFour?: number;
  public PhysicianSignatureFive?: number;
  public PhysicianSignatureSix?: number;
  public UserId: number;
  public KeyImageIds:string[] = [];
  public StructuredDiagnosisColumnItems: StructuredDiagnosisColumnItem[];
  public StructuredDiagnosisColumns: StructuredDiagnosisColumn[];
  public TypeModality: number;
}
